import { render, staticRenderFns } from "./WarningDialog.vue?vue&type=template&id=58ff367c&"
import script from "./WarningDialog.vue?vue&type=script&lang=js&"
export * from "./WarningDialog.vue?vue&type=script&lang=js&"
import style0 from "./WarningDialog.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports